"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.event = exports["default"] = void 0;

var _universalCookie = _interopRequireDefault(require("universal-cookie"));

var _Browser = _interopRequireDefault(require("./Browser"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

var ClevertapHandler = /*#__PURE__*/function () {
  function ClevertapHandler() {
    _classCallCheck(this, ClevertapHandler);
  }

  _createClass(ClevertapHandler, null, [{
    key: "initialize",
    value: function initialize(CLEVERTAP_ID) {
      if (!CLEVERTAP_ID) {
        throw new Error("Error. Can't initialize Clevertap without Id.\n       Please call initialize with an Id. Eg. initialize(\"ABCD-123-456-WXYZ\")");
      }

      if (!window.clevertap) {
        window.clevertap = {
          event: [],
          profile: [],
          region: 'in',
          account: [],
          onUserLogin: [],
          notifications: []
        };
        window.clevertap.account.push({
          'id': CLEVERTAP_ID
        });

        (function () {
          var wzrk = document.createElement('script');
          wzrk.type = 'text/javascript';
          wzrk.async = true;
          wzrk.src = ('https:' == document.location.protocol ? 'https://d2r1yp2w7bby2u.cloudfront.net' : 'http://static.clevertap.com') + '/js/a.js';
          var s = document.getElementsByTagName('script')[0];
          s.parentNode.insertBefore(wzrk, s);
        })();
      }
    }
  }, {
    key: "profile",
    value: function profile(payload) {
      window.clevertap.profile.push(payload);
    }
  }, {
    key: "onUserLogin",
    value: function onUserLogin(payload) {
      window.clevertap.onUserLogin.push(payload);
    }
  }, {
    key: "logout",
    value: function logout() {
      window.clevertap.logout();
    }
  }]);

  return ClevertapHandler;
}();

exports["default"] = ClevertapHandler;

var event = function event() {
  var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'Dashboard CTA clicked';
  var payload = arguments.length > 1 ? arguments[1] : undefined;

  try {
    var platform = 'PayU Web';
    var cookies = new _universalCookie["default"]();
    var extraArgs = {
      Platform: platform,
      Device: _Browser["default"].getWebDevice(),
      MID: payload.hasOwnProperty("MID") ? payload.MID : cookies.get('mid')
    };

    if (payload && window.clevertap) {
      console.log(name, Object.assign(payload, extraArgs));
      window.clevertap.event.push(name, Object.assign(payload, extraArgs));
    } else {
      window.clevertap && window.clevertap.event.push(name, extraArgs);
    }
  } catch (error) {
    console.error ? console.error("Error:", error) : console.log("Error:", error);
  }
};

exports.event = event;